import { useEffect, useState } from 'react';

import styles from './Spinner.module.css';

const DEFAULT_DELAY_IN_MS = 250;

export interface SpinnerProps {
  /** The `aria-valuetext` of the spinner. */
  ariaValueText: string;
  /** Delay in milliseconds after which the spinner becomes visible. The default is `250`. */
  showAfterMs?: number;
}

/** Represents a component to display a spinner. */
export const Spinner = ({ ariaValueText, showAfterMs = DEFAULT_DELAY_IN_MS }: SpinnerProps) => {
  const [visible, setVisible] = useState(() => (showAfterMs === 0 ? true : false));

  useEffect(() => {
    if (showAfterMs === 0) {
      return;
    }
    const t = window.setTimeout(() => {
      setVisible(true);
    }, showAfterMs);

    return () => {
      window.clearTimeout(t);
    };
  });

  if (!visible) {
    return null;
  }

  return (
    <div className={styles['spinner-container']}>
      <div className={styles['spinner']} role="progressbar" aria-label="Spinner" aria-valuetext={ariaValueText}></div>
    </div>
  );
};
